var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-select",
    _vm._b(
      { attrs: { value: _vm.value }, on: { change: _vm.change } },
      "el-select",
      _vm.$attrs,
      false
    ),
    _vm._l(_vm.options, function ({ value, label }) {
      return _c("el-option", {
        key: value,
        attrs: { label: label, value: value },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }